import { subject } from "@casl/ability";
import { Group } from "@mantine/core";
import { ColumnDef, createColumnHelper } from "@tanstack/react-table";
import ContextMenuRow from "./ContextMenuRow";

const columnHelper = createColumnHelper<TDesafioCategoria>();

const columns: ColumnDef<TDesafioCategoria>[] = [
  columnHelper.accessor("nome", {
    header: "Nome",
    enableSorting: true,
    enableColumnFilter: true
  }),
  columnHelper.display({
    id: "actions",
    cell: (properties) => {
      const categorias = subject("TDesafioCategoria", properties.row.original);

      return (
        <Group justify="right" gap={2}>
          <ContextMenuRow categorias={categorias} />
        </Group>
      );
    }
  })
];

export default columns;
